import { useEffect } from 'react'

// No lost work, no scary prompts (release 3.3, Back model B8).
//
// Wizards keep their answers in a draft (the import keeps them on the server),
// so leaving one never needs the browser's "Leave site?" box. The one thing
// that can still be lost is free text a person typed and has not saved: a
// reason, a note, a pasted pack. A form with such text asks the browser to
// warn before the page is closed or reloaded, and only while the text is
// there and unsaved. It covers closing and reloading the tab: a move inside the
// console (a link, Back) raises no browser event to hang it on.

export function useLeavePrompt(unsaved: boolean): void {
  useEffect(() => {
    if (!unsaved) return
    const warn = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      // Chrome before 119 and older Safari still read the return value.
      e.returnValue = ''
    }
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [unsaved])
}
